module.exports = __webpack_public_path__ + "static/media/philosophy_symbol.359e5b8a.png";